import React from "react";
import Grid from "@mui/material/Grid";
import MentorGridBox from "./components/mentor_box";
import styles from "./mentor_list_grid.module.scss";

export const MentorListGrid = ({ mentorList }) => {
  return (
    <section className={styles.section_mentor_list_grid}>
      <div className="container">
        <div className={styles.heading_wrapper}>
          <h2>Our International Student Mentors</h2>
          <p className={`font-medium`}>
            Students are at the heart of everything we do. To bring you the
            unique insight that only an international student can, take
            advantage of our network of international students and alumni to ask
            your burning questions about studying abroad!
          </p>
        </div>

        {/* <Grid container spacing={2}>
          <Grid item xs={12} sm={8} md={6}>
            <h2>Our International Student Mentors</h2>
            <p className={`font-medium`}>
              Students are at the heart of everything we do. To bring you the
              unique insight that only an international student can, take
              advantage of our network of international students and alumni to
              ask your burning questions about studying abroad!
            </p>
          </Grid>
          <Grid
            item
            xs={12}
            sm={4}
            md={6}
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="flex-end"
          >
            <button className="btn btn-outline">All Mentors</button>
          </Grid>
        </Grid> */}

        <Grid
          sx={{ marginTop: 2 }}
          container
          spacing={3}
          justifyContent="center"
        >
          {mentorList?.length > 0 &&
            mentorList?.map((item, i) => (
              <Grid key={i} item xs={12} sm={6} md={4} lg={3}>
                <MentorGridBox
                  iconVerified={item?.iconVerified}
                  avatar={item?.profileImageSrc}
                  name={`${item?.firstName} ${item?.middleName} ${item?.lastName}`}
                  country={item?.countryName}
                  // university={item?.university?.name}
                  courseName={item?.courseName}
                  countryName={item?.countryName}
                  universityName={item?.universityName}
                  designation={item.designation}
                  link={item.link || "#"}
                  type={"Mentor"}
                />
              </Grid>
            ))}
        </Grid>
      </div>
    </section>
  );
};

export default MentorListGrid;
